<template>
  <div class="resource">
    <div class="sift">
      <div class="title">人员查询</div>
      <div class="inquire">
        <el-form :model="formInline" class="demo-form-inline" size="small" :inline="true">
          <el-form-item>
            <strong slot="label">部门</strong>

            <el-select v-model="formInline.cbowhId" placeholder="请选择部门" clearable filterable @change="inquire">
              <el-option v-for="(item, index) in deptList" :key="index" :label="item.name" :value="item.cbOwhId"></el-option>
        </el-select>
          </el-form-item>
          <el-form-item>
            <strong slot="label">人员</strong>
            <el-input
              v-model="formInline.name"
              placeholder="请输入人员"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          <el-button
            v-if="activeName === 'first'"
            type="warning"
            icon="el-icon-download"
            :loading="exportLoading"
            @click="handleExport"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
      </div>
    </div>
    <div class="detail">
      <el-tabs v-model="activeName">
        <el-tab-pane label="人员列表" name="first">
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            v-loading="loading"
            :max-height="tableHeight"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          >
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <!-- <el-table-column prop="ofOwhResourceId" label="序号"></el-table-column> -->
            <el-table-column prop="cbowhName" label="部门">
              <!-- <template slot-scope="scope">
                <a @click="handleDetail(scope.row)" class="link">{{scope.row.restypeName}}</a>
              </template> -->
            </el-table-column>
            <el-table-column prop="ofrresourceName" label="岗位">
              <!-- <template slot-scope="scope">
                <a @click="handleDetail(scope.row)" class="link">{{scope.row.restypeName}}</a>
              </template> -->
            </el-table-column>
            <el-table-column prop="ofrthingName" label="人员">
              <!-- <template slot-scope="scope">
                <DictTag :options="dropDown.kind" :value="scope.row.kind"/>
              </template> -->
            </el-table-column>
            <!-- <el-table-column prop="quantity" label="数量" align="right">
            </el-table-column> -->
            <!-- <el-table-column prop="price" label="成本单价" align="right">
              <template slot-scope="scope">
                {{scope.row.price | comdify}}
              </template>
            </el-table-column>
            <el-table-column prop="linetotal" label="成本合计" align="right">
              <template slot-scope="scope">
                {{scope.row.linetotal | comdify}}
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              label="操作"
              fixed="right"
              width="180">
              <template slot-scope="scope">
                <el-button
                  size="mini" icon="el-icon-view" type="text"
                  @click="handleDetail(scope.row)">详情</el-button>
                <el-button
                  size="mini" icon="el-icon-edit" type="text"
                  @click="handleEdit(scope.row)">编辑</el-button>
                <el-button
                  size="mini" icon="el-icon-delete" type="text"
                  @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 30, 40]"
            :page-size="pageSize"
            layout="->, total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </el-tab-pane>

        <el-tab-pane label="组织架构图" name="two">
          <!-- <div>
            <el-button @click="exportOrgChart" type="warning">导出</el-button>
            <el-button @click="handleLoad" type="primary">{{ text }}</el-button>
          </div> -->
          <div style="overflow: auto;height: 860px">
           <!-- <vue2-org-tree :data="orgTree" :label-class-name="labelClassName"
                          @on-expand="onExpand"
                          :renderContent="renderContent"
                          collapsable :horizontal="false"></vue2-org-tree> -->
                        <OrgTree id="container" v-if="activeName === 'two'"/>
          </div>

        </el-tab-pane>
        <el-tab-pane label="人员编制" name="three">
          <el-table
            :data="ryData"
            tooltip-effect="dark"
            style="width: 100%"
            :max-height="tableHeight"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          >
            <el-table-column prop="deptName" label="部门">
            </el-table-column>
            <el-table-column prop="quantity" label="编制人数">
            </el-table-column>
            <el-table-column prop="zgrs" label="在岗人数">
            </el-table-column>
            <el-table-column prop="zprs" label="招聘人数">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="岗位编制" name="four">
          <el-table
            :data="gwData"
            tooltip-effect="dark"
            style="width: 100%"
            :max-height="tableHeight"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
          >
            <el-table-column prop="deptName" label="部门">
            </el-table-column>
            <el-table-column prop="remarks" label="岗位名称">
            </el-table-column>
            <el-table-column prop="quantity" label="编制人数">
            </el-table-column>
            <el-table-column prop="zgrsName" show-overflow-tooltip label="在岗人员">
            </el-table-column>
            <el-table-column prop="zgrs" label="在岗人数">
            </el-table-column>
            <el-table-column prop="zprs" label="招聘人数">
            </el-table-column>

          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 新增和编辑弹框 -->
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="资源名称" prop="restypeName">
          <el-input v-model="ruleForm.restypeName" placeholder="请输入资源名称"></el-input>
        </el-form-item>
        <el-form-item label="种类" prop="kind">
          <el-select v-model="ruleForm.kind" placeholder="请选择资源种类" style="width:100%">
            <el-option v-for="(item, index) in dropDown.kind" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易类型" prop="kindDealType">
          <el-select v-model="ruleForm.kindDealType" placeholder="请选择资源交易类型" style="width:100%">
            <el-option v-for="(item, index) in dropDown.kindDealType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url';
import { mapState } from 'vuex'
import qs from 'qs'
import * as XLSX from 'xlsx'
import DictTag from '@/components/DictTag.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import vue2OrgTree from 'vue2-org-tree'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import OrgTree from './OrgTree'
import 'vue2-org-tree/dist/style.css'
export default {
  components: {
    DictTag,
    Treeselect,
    vue2OrgTree,
    OrgTree
  },
  computed: {
    ...mapState({
      dropDown: state => state.dropDown.dropDown
    })
  },
  data () {
    return {
      formInline: {
        name: '',
        cbowhId: null
      },
      activeName: 'first',
      tableData: [],
      dialogFormVisible: false,
      // 弹出层标题
      title: '',
      ruleForm: {
        restypeName: '',
        kind: '',
        kindDealType: ''
      },
      rules: {
        restypeName: [{ required: true, message: '请输入资源名称', trigger: 'submit' }],
        kind: [{ required: true, message: '请选择资源种类', trigger: 'submit' }],
        kindDealType: [{ required: true, message: '请选择资源交易类型', trigger: 'submit' }]
      },
      // 编辑按钮不可点
      edit: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      exportLoading: false,
      ids: [],
      isLoading: false,
      labelClassName: 'bg-color-orange',
      deptList: [],
      orgTree:{},
      defaultProps: {
        /** 唯一标识 **/
        value: 'Id',
        /** 标签显示 **/
        label: 'label',
        /** 子级 **/
        children: 'children'
      },
      tableHeight: window.innerHeight - 245,
      text: '一键展开',
      ryData: [],
      gwData: []
    }
  },
  created() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 245
    })
    window.onresize = () => { // 屏幕尺寸变化就重新赋值
      return (() => {
        this.tableHeight = window.innerHeight - 245
      })()
    }
    this.getList()
    this.init()
    this.getBzData()
    // this.getOrgTree()
  },
  methods: {
    getExportTextWidth (value) {
      if (value === undefined || value === null) {
        return 0
      }
      return String(value).split('').reduce((width, char) => {
        return width + (char.charCodeAt(0) > 255 ? 2 : 1)
      }, 0)
    },
    setWorksheetCols (workSheet, tableData) {
      if (!tableData || !tableData.length) {
        return
      }
      const colCount = tableData[0].length
      workSheet['!cols'] = Array.from({ length: colCount }).map((_, colIndex) => {
        const maxWidth = tableData.reduce((width, row) => {
          return Math.max(width, this.getExportTextWidth(row[colIndex]))
        }, 0)
        return {
          wch: Math.min(Math.max(maxWidth + 2, 12), 24)
        }
      })
    },
    async handleExport () {
      this.exportLoading = true
      try {
        const res = await this.$http.get(url.getOwhUserList, {
          params: {
            pageNum: 1,
            pageSize: 1000,
            cbowhId: this.formInline.cbowhId == '0' ? '' : this.formInline.cbowhId,
            ofrthingName: this.formInline.name
          }
        })
        if (res.data.code === 200) {
          const list = res.data.data.list || []
          if (!list.length) {
            this.$message.warning('暂无可导出数据')
            return
          }
          const tableData = [
            ['部门', '岗位', '人员'],
            ...list.map(item => [
              item.cbowhName === undefined || item.cbowhName === null ? '' : item.cbowhName,
              item.ofrresourceName === undefined || item.ofrresourceName === null ? '' : item.ofrresourceName,
              item.ofrthingName === undefined || item.ofrthingName === null ? '' : item.ofrthingName
            ])
          ]
          const workSheet = XLSX.utils.aoa_to_sheet(tableData)
          this.setWorksheetCols(workSheet, tableData)
          const workBook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workBook, workSheet, '人员列表')
          XLSX.writeFile(workBook, '人员列表.xlsx')
        }
      } finally {
        this.exportLoading = false
      }
    },
    // 获取人员编制和岗位编制
    getBzData () {
      this.$http.get(url.bzinfo).then(res => {
        if (res.data.code === 200) {
          this.ryData = res.data.data.rybz || []
          this.gwData = res.data.data.gwbz || []
        }
      })
    },
    handleLoad(){
      if (this.text === '一键收起') {
        this.text = '一键展开'
        this.collapse(this.orgTree.children, false)
      } else {
        this.text = '一键收起'
        this.collapse(this.orgTree.children, true)
      }
    },
    // 渲染节点
    renderContent (h, data) {
      const width = 35
      const height = 165
      if (data.level === 2) {
        return (
          <div style={{
            width: `${width}px`,
            height: `${height}px`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            writingMode: 'tb',
            letterSpacing: '0.2em'
          }}>

            <span>{data.label}
            </span>
            <span style={{
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '25px',
              height: '25px',
              border: '1px solid #1890ff',
              borderRadius: '50%', // 50% 变成正圆
              backgroundColor: '#e6f7ff',
              color: '#1890ff',
              fontSize: '14px',
              letterSpacing: '0',
              position: 'absolute',
              bottom: 0,
              left: '0',
              writingMode: 'rl-tb'
            }}>{data.other}</span>
          </div>
        )
      } else if (data.level !== 1) {
        return (
          <div style={{
            width: `${width}px`,
            height: `${height}px`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            writingMode: 'tb',
            letterSpacing: '0.2em'
          }}>
            <span>{data.label}</span>
          </div>
        )
      } else {
        return (
          <div>
            <span>{data.label}</span>
          </div>
        )
      }
    },
    // 展开
    onExpand (e, data) {
      if ('expand' in data) {
        data.expand = !data.expand
        if (data.children && data.id !== 1) {
          this.collapse(data.children, data.expand)
        }
      } else {
        this.$set(data, 'expand', true)
      }
    },
    collapse (list, expand) {
      var _this = this
      list.forEach(function (child) {
        child.expand = expand
        child.children && _this.collapse(child.children, expand)
      })
    },
    toggleExpand (data, val) {
      var _this = this
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this.$set(item, 'expand', val)
          if (item.children) {
            _this.toggleExpand(item.children, val)
          }
        })
      } else {
        this.$set(data, 'expand', val)
        if (data.children) {
          _this.toggleExpand(data.children, val)
        }
      }
    },
    init () {
      this.$http.get(url.getDeptList, {
        params: {
        // cbRestypeId: this.formInline.cbRestypeId,
        // name: this.formInline.name
        }
      }).then(res => {
        if (res.data.code === 200) {
          // const data = {id: 0, label: '顶级节点', children: [] };
          // data.children = this.getTree(res.data.data);
          // this.cbOwhTree.push(data)
          this.deptList = res.data.data
        }
      })
    },
    // 查询按钮
    inquire () {
      this.loading = true
      this.pageNum = 1
      this.getList()
    },
    // 重置按钮
    reset () {
      for (const key in this.formInline) {
        this.formInline[key] = ''
      }
      this.loading = true
      this.pageNum = 1
      this.getList()
    },
    // 表格的选中框事件
    handleSelectionChange (rows) {
      this.ids = rows.map(item => item.cbRestypeId)
      this.edit = rows.length === 1
    },
    getOrgTree () {
      this.$http.get(url.getOwhUserOrgTree).then(res => {
        if (res.data.code === 200) {
          this.orgTree = res.data.data
          // this.$nextTick(() => {
          //   this.secondExpand(this.orgTree)
          // })
        }
      })
    },
    // 获取字典数据
    getList () {
      // 获取列表数据
      this.$http.get(url.getOwhUserList, {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          cbowhId: this.formInline.cbowhId == '0' ? '' : this.formInline.cbowhId,
          ofrthingName: this.formInline.name
        }
      }).then(res => {
        // console.log(res);
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          // 新增项目
          if (this.title === '新增资源') {
            this.$http.post(url.addCbResType, qs.stringify(this.ruleForm)).then(res => {
              this.isLoading = false
              if (res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.dialogFormVisible = false
                this.pageNum = 1
                this.loading = true
                this.getList()
              }
            })
          } else { // 编辑资源
            this.$http.post(url.editCbResType, qs.stringify(this.ruleForm)).then(res => {
              // console.log(res);
              this.isLoading = false
              if (res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.dialogFormVisible = false
                this.pageNum = 1
                this.loading = true
                this.getList()
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 新增项目按钮
    handleAdd () {
      this.title = '新增资源'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        // 清除表单校验效果
        this.$refs.ruleForm.clearValidate()
      })
      // 初始化表单内容
      for (const key in this.ruleForm) {
        this.ruleForm[key] = ''
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.loading = true
      this.getList()
    },
    // 编辑按钮
    handleEdit (row) {
      if (this.$refs.ruleForm) {
        this.$nextTick(() => {
          // 清除表单校验效果
          this.$refs.ruleForm.clearValidate()
        })
      }

      const id = row.cbRestypeId || this.ids[0]
      this.dialogFormVisible = true
      this.title = '编辑资源'
      this.$http.get(url.getResType, { params: { cbRestypeId: id } }).then(res => {
        if (res.data.code === 200) {
          this.ruleForm = res.data.data
        }
      })
    },
    // 删除按钮
    handleDel (row) {
      this.$confirm('此操作将永久删除该资源类型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(url.removeCbResType, qs.stringify({ cbRestypeId: row.cbRestypeId })).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.pageNum = 1
            this.loading = true
            this.getList()
          }
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      })
    },
    // 查看详情按钮
    handleDetail (row) {
      // let cbRestypeId = row.cbRestypeId
      // this.$router.push("/resource/kind/" + cbRestypeId)
      // let obj = {
      //   path: "/resource/kind/" + cbRestypeId,
      //   name: "kindDetail",
      //   label: "资源详情",
      //   cbRestypeId: cbRestypeId,
      //   children: []
      // };
      // this.$store.commit("selectMenu", obj);
    },
    exportOrgChart () {
      const element = document.querySelector('.org-tree'); // 获取组织架构图的容器元素
      html2canvas(element, {
        backgroundColor: '#ffffff',
        scale: 2,
        useCORS: true
      }).then(canvas => {
        // 创建一个图片元素
        let img = new Image();
        img.src = canvas.toDataURL('image/png');

        // 创建并触发下载
        img.onload = () => {
          let w = img.width;
          let h = img.height;
          let canvas2 = document.createElement('canvas');
          let ctx = canvas2.getContext('2d');
          canvas2.width = w;
          canvas2.height = h;
          ctx.drawImage(img, 0, 0, w, h);
          saveAs(canvas2.toDataURL('image/png'), '组织架构图.png');
        };
      });
    }
  },
  watch: {
    // formInline: {
    //   handler(newValue, oldValue) {
    //     // console.log(newValue);
    //     if(newValue.cbowhId != '0') {
    //       // console.log(11111);
    //       this.pageNum = 1
    //       this.loading = true
    //       this.getList()
    //     }
    //   },
    //   deep: true
    // }
  }
}
</script>

<style lang="scss">
.resource {
  // padding: 16px;
  .sift,.detail {
    width: 100%;
    background-color: #fff;
    box-shadow: 2px 3px 8px 0px rgba(208, 208, 208, 0.5);
    border-radius: 11px;
    padding: 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
  }
  .title {
    height: 14px;
    font-size: 14px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 15px;
    padding-left: 8px;
    border-left: #0c75e5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
  }
  .detail {
    margin-bottom: 0;
    .el-table {
      margin-bottom: 39px;
    }
  }
  .modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
    .close {
      position: absolute;
      right: 3%;
      top: 2%;
      color: #fff;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      background-color: rgba(208, 208, 208, 0.5);
      border-radius: 50%;
      cursor: pointer;
    }
    .close:hover {
      background-color: rgba(250, 250, 250, 0.5);
    }
    >img {
      width: 90%;
      height: 90%;
      cursor: pointer;
    }
  }
}
::v-deep .el-dialog {
  margin: 0 auto;
  max-height: calc(100% - 72px);
  // height: calc(100% - 72px);
}
::v-deep .el-dialog__body {
  padding: 10px 0 10px 20px;
  margin-right: 20px;
  max-height: calc(100vh - 206px);
  // height: calc(100vh - 206px);
  overflow: auto;
}
.bg-color-orange{
  border: 1px solid #597EF7 !important;
  background-color: #C6D7FF !important;color: #1D39C4 !important;
}
/* 修改所有线条 */
.org-tree-node:before,.org-tree-node:after {
  border-color: #1890ff !important;  /* 所有连接线 */
}
</style>
